export const CurrencySymbol = () => {
  //return "⍧";
  return <>ℂ</>;
};
